import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";



// Get Table Data
export const SidebarDistributionLineLocationMasterTableDataAPI = createAsyncThunk("SidebarDistributionLineLocationMasterTableData", async ({ data }) => {
    const {
        M_WardID,
        M_Distri_WS_LocationID,
        token,
        From,
        To,
        M_UsersID,
        DashProjectTypeId
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == '6') {
        url = `${BaseUrl}/Master/Get_WEB_M_Distri_WS_Location_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_Distri_WS_LocationID ? M_Distri_WS_LocationID : '0'}&M_UserID=${M_UsersID}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/Master/Get_WEB_M_WS_Location_Select?M_WS_LocationID=${M_Distri_WS_LocationID ? M_Distri_WS_LocationID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UsersID}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const SidebarDistributionLineLocationMasterTableDataSlice = createSlice({
    name: "SidebarDistributionLineLocationMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SidebarDistributionLineLocationMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SidebarDistributionLineLocationMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(SidebarDistributionLineLocationMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const SidebarDistributionLineLocationMasterTableDataReducer = SidebarDistributionLineLocationMasterTableDataSlice.reducer


export const SidebarDistributionLineLocationMasterPostDataAPI = createAsyncThunk("SidebarDistributionLineLocationMasterPostData", async ({ data }) => {
    const {
        M_Distri_WS_LocationID,
        M_WS_LocationID,
        M_WardID,
        LocationDetails,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if(DashProjectTypeId == '6'){
        formdata.append("M_Distri_WS_LocationID", M_Distri_WS_LocationID);
    }else{
        formdata.append("M_WS_LocationID", M_WS_LocationID);
    }
 
    formdata.append("M_WardID", M_WardID);
    formdata.append("LocationDetails", LocationDetails);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url 
    if(DashProjectTypeId == '6'){
        url=`${BaseUrl}/Master/Post_WEB_M_Distri_WS_Location_InsertUpdate`
    }else{
        url=`${BaseUrl}/Master/Post_WEB_M_WS_Location_InsertUpdate`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const SidebarDistributionLineLocationMasterPostDataSlice = createSlice({
    name: "SidebarDistributionLineLocationMasterPostData",
    initialState: {
        isPostLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SidebarDistributionLineLocationMasterPostDataAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(SidebarDistributionLineLocationMasterPostDataAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(SidebarDistributionLineLocationMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const SidebarDistributionLineLocationMasterPostDataReducer = SidebarDistributionLineLocationMasterPostDataSlice.reducer

// -----------------Delete API ---------------

export const SidebarDistributionLineLocationMasterDeleteAPI = createAsyncThunk("SidebarDistributionLineLocationMasterDelete", async ({ data }) => {
    const {
        M_Distri_WS_LocationID,
        M_WS_LocationID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();

    if(DashProjectTypeId == '6'){
        formdata.append("M_Distri_WS_LocationID", M_Distri_WS_LocationID);
    }else{
        formdata.append("M_WS_LocationID", M_WS_LocationID);
    }
  
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url 
    if(DashProjectTypeId == '6'){
        url=`${BaseUrl}/Master/WEB_M_Distri_WS_Location_Delete`
    }else{
        url=`${BaseUrl}/Master/WEB_M_WS_Location_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const SidebarDistributionLineLocationMasterDeleteSlice = createSlice({
    name: "SidebarDistributionLineLocationMasterDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SidebarDistributionLineLocationMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(SidebarDistributionLineLocationMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(SidebarDistributionLineLocationMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const SidebarDistributionLineLocationMasterDeleteReducer = SidebarDistributionLineLocationMasterDeleteSlice.reducer